{
  "version": 1,
  "asset_id": "947909bb-6294-4755-987c-ea42b058f343",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/947909bb-6294-4755-987c-ea42b058f343/revision-hub-annotated-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/947909bb-6294-4755-987c-ea42b058f343/revision-hub-annotated-1200.webp",
  "original_filename": "revision-hub-annotated-1200.webp",
  "size": 68806,
  "content_type": "image/webp",
  "created_at": "2026-10-05T21:16:43Z"
}
